<template>
  <div class="container-fluid mt--12">
    <actions/>
    <div class="row">
      <div class="col-sm-12 col-lg-12">
        <grafico/>
      </div>
    </div>
  </div>
</template>

<script>
import DemonstrativoRepasseGraficoDetalhado from "./DemonstrativoRepasseGraficoDetalhado";
import DemonstrativoRepasseActions from "./DemonstrativoRepasseActions";
export default {
  name: "DemonstrativoRepasseContainerGrafico",
  components: {
    "grafico": DemonstrativoRepasseGraficoDetalhado,
    "actions": DemonstrativoRepasseActions
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/demonstrativo/repasse/DemonstrativoRepasseContainerGrafico.vue